import { FieldShell } from '../FieldShell'
import type { FieldComponentProps } from '../rendererContext'
import type { TextConfig } from '../types'
import { controlClass, useControlMeta } from './useControlMeta'

export function TextField({ field, path, value, errors }: FieldComponentProps) {
  const meta = useControlMeta(field, path, errors)
  const config = field.config as TextConfig | undefined

  if (field.display_only) {
    return (
      <FieldShell field={field} path={path} errors={errors}>
        <div id={meta.id} className="form-control-plaintext">
          {value == null ? '' : String(value)}
        </div>
      </FieldShell>
    )
  }

  return (
    <FieldShell field={field} path={path} errors={errors}>
      <input
        id={meta.id}
        type="text"
        className={controlClass('form-control', meta.classNames.control, meta.hasErrors)}
        value={value == null ? '' : String(value)}
        placeholder={config?.placeholder}
        disabled={meta.disabled}
        aria-invalid={meta.ariaInvalid}
        aria-required={meta.ariaRequired}
        aria-describedby={meta.describedBy}
        onChange={(event) => meta.setFieldValue(path, event.target.value)}
        onBlur={() => meta.notifyBlur(path)}
      />
    </FieldShell>
  )
}
